import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { LoginShell } from '@app/auth/login-shell/login-shell.service';
import { ForgotPasswordComponent } from '@app/auth/forgot-password/forgot-password.component';
import { getRoutePath, PlRoute } from '@app/utils/routes';
import { PasswordSetupComponent, PasswordSetupRouteData } from '@app/auth/password-setup/password-setup.component';

const routes: Routes = [
  LoginShell.childRoutes([
    { path: getRoutePath(PlRoute.login, false), component: LoginComponent },
    {
      path: getRoutePath(PlRoute.retrieveCredentials, false),
      component: ForgotPasswordComponent,
    },
    {
      path: getRoutePath(PlRoute.resetPassword, false),
      component: PasswordSetupComponent,
      data: { createPassword: false } as PasswordSetupRouteData,
    },
    {
      path: getRoutePath(PlRoute.creationPassword, false),
      component: PasswordSetupComponent,
      data: { createPassword: true } as PasswordSetupRouteData,
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AuthRoutingModule {}
